import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ValidationService } from '../shared/_services/validation.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: any = FormGroup;
  loginError: boolean = false;
  errorMessage: String="";
  public loading = false;

  constructor( private fb: FormBuilder, private http: AuthService, private router: Router, private validation: ValidationService) {
    let authToken = this.http.getToken;
    if(authToken) {
      console.log(this.router);
      this.router.navigate(['/customerReport']);
    }
   }

  ngOnInit() {
    //reactive form builder
    this.loginForm = this.fb.group({
      email : ['', [Validators.required, , Validators.pattern(this.validation.email_regexPattern)]],
      // userName : ['', [Validators.required]],
      password : ['', [Validators.minLength(1), Validators.maxLength(15), Validators.required]]
    });

    // if(localStorage.getItem('token') !== null){
    //   this.router.navigate(['/dashboard']);
    // }


  }

  //login function
  login(loginData){
    this.loading = true;
    var loginObj = {
      email : decodeURI(loginData.email.trim()),
      password : loginData.password.trim()
    }
    this.http.login(loginObj).subscribe(
      res=>{
        this.loading = false;
        if(res){
          this.loginError = false;
          this.router.navigate(['/customerReport']);
          localStorage.setItem('currentUser', JSON.stringify(res.responseObj));
            let accessToken = res.responseObj.token;
            localStorage.setItem('token', accessToken);
        }else{
          this.loginError = true;
          // this.loginForm.reset();
          this.errorMessage = res.message;
        }
      },
      error=>{
        this.loading = false;
        this.loginError = true;
        // this.loginForm.reset();
        this.errorMessage = error.message;
      }
    )
  }

  //clearing error messages
  clearExisitingErrors(){
    this.loginError = false;
    this.errorMessage = "";
  }
  //forgot password function
  forgotPassword(){
    this.router.navigate(['/forgotPassword']);
  }

  //register function
  register(){
    this.router.navigate(['/registration']);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts